import React, { useContext, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { Container } from '../Library'
import { Link } from 'react-router-dom'
import "./Service.css"
import { RoleContext } from '../Role/RoleContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWrench, faHourglass, faHistory } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'

function ServiceInform() {
    const role = useContext(RoleContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.service

    const pageItem = [
        {title: lang.repair_service, description: lang.repair_service_description, icon: faWrench, url: "/inform"},
        {title: lang.repair_status, description: lang.repair_status_desc, icon: faHourglass, url: "/status"},
        {title: lang.repair_history, description: lang.repair_history_desc, icon: faHistory, url: "/history"}
    ]

    useEffect(()=>{
        setDocumentTitle("Repair Service")
    },[])

    return (
        <Container id="service-inform" topbarTitle={lang.repair_service}>
            <div style={{ marginBottom: 30 }}>{lang.service_desc}</div>
            <Row>
                { pageItem.map((item, key) =>
                <Col key={key} xs={6} lg={4}>
                    <ServiceItem 
                    icon={item.icon}
                    title={item.title} 
                    description={item.description}
                    to={item.url}
                    />
                </Col>
                )}
            </Row>
        </Container>
    )
}

function ServiceItem({ icon, title, description, to }){
    return(
        <Link className="service-item" to={to}>
            <FontAwesomeIcon icon={icon} style={{ fontSize: 35, marginBottom: 13 }} color="#00275e"/>
            <div className="title">{title}</div>
            <div className="desc">{description}</div>
        </Link>
    )
}

export default ServiceInform
